export default "__VITE_ASSET__CDr1yKfX__"